import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { VForm } from 'vuetify/lib/components';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection3MultiInputForm',
  props: {
    isEditing: { type: Boolean },
    isValid: { type: Boolean },
    data: null,
    label: null
  },
  emits: ["update:isValid", "update:data"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValid', value: boolean): void;
  (e: 'update:data', value: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isEditing: boolean;
  isValid: boolean;
  data: string[];
  label: string;
};

const $t = i18n.t.bind(i18n);


const form = ref<InstanceType<typeof VForm> | null>(null);



const updateIsValid = (value: boolean) => {
  emits('update:isValid', value);
};

const updateData = (value: string, index: number) => {
  const data = [...props.data];
  data[index] = value;
  emits('update:data', data);
};

const handleAddClick = () => {
  emits('update:data', [...props.data, '']);
};

const handleDeleteClick = (index: number) => {
  const data = [...props.data];
  data.splice(index, 1);
  emits('update:data', data);
};

onMounted(() => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,$t, props, form, emits, updateIsValid, updateData, handleAddClick, handleDeleteClick, VForm, sharedMessages }
}

})